// extracted by mini-css-extract-plugin
export var copyableField = "_na-4";
export var customerBadge = "_na-0";
export var customerInfoTitle = "_na-2";
export var details = "_na-1";
export var dropdownContainer = "_na-5";
export var dropdownImage = "_na-6";
export var editAssigneeForm = "_na-a";
export var editButton = "_na-3";
export var email = "_na-7";
export var hidden = "_na-d";
export var input = "_na-8";
export var saveButton = "_na-b";
export var shopifyIcon = "_na-c";
export var suggestionBadge = "_na-e";
export var suggestionText = "_na-f";
export var username = "_na-9";